import { Environment } from "../utils/Environment";

const apiUrl = Environment.getApiUrl();

const logout = async (navigate: (path: string) => void) => {
  try {
    const refresh_token = localStorage.getItem("refresh_token");

    if (!refresh_token) {
      console.warn("No refresh token found. Clearing session data.");
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      alert("Logged out successfully!");
      navigate("/home"); // Redirect to home
      return;
    }

    const response = await fetch(`${apiUrl}/logout`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ refresh_token }),
    });

    if (!response.ok) {
      throw new Error("Logout failed");
    }

    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    // alert("Logged out successfully!");
    navigate("/home"); // Redirect to home
  } catch (err) {
    console.error("Logout failed:", err);
    alert("Failed to log out. Please try again.");
  }
};

export default logout;